import React, { Fragment } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { submit, isValid, getFormValues, getFormSyncErrors } from "redux-form";
import cx from "classnames";

import Loader from "components/Loader";

import { showNotification } from "actions/ui";

import { NotificationTypes } from "constants/index";

import NotificationPortal from "../../components/Notification/NotificationPortal";
import TabContent from "./TabContent";
import CheckBoxToggle from "components/Common/CheckBoxToggle";
import ButtonSelectPopup from "components/Common/ButtonSelectPopup";
import StatusSelect from "./StatusSelect";
import ActionSelect from "./ActionSelect";
import NewAppealForm from "./Form";
// import NewAppealForm from './Form/index_old.js';

import PersonPageContent from "components/PersonPage/MainContent";
import CustomerTabContent from "components/CustomerPage/MainContent";
import ViewListQuality from "./CallQuality/ViewListQuality";
import LinkAppeal from "./LinkAppeal";
import LinkObjects from "./LinkObjects";
import {
    // unlockAppealForm,
    // repeatAppeal,
    removeRefreshAppealModal,
    getAppealVersion,
    setSaveAndCreateNew,
    lockAppealForm,
    saveAppeal,
    setStatusModalVisibility,
    showValidationNotification,
    createNewAppeal,
    setRequiredCustomer,
    setAppealIsSaveAndCreateNew,
	saveFeedback,
	unlockAppealAndClearSourceWithoutForm
} from "modules/appeal/actions";
// import downloadCSV from "actions/downloadCSV";
// import { updateCurrentTabUrl } from 'actions/index';

import { toggleTabsTripleCollapseState } from "reducers/layoutCollapse";

import notificationStyle from "styles/modules/notification.module.scss";
import { withTranslation } from "react-i18next";
import {
	changeFormListener, extractAppealFromState, extractCustomerFromState,
    getCustomerTabNames,
    isOrganization,
    isServiceobjectType,
    isIndividual,
    getValueOrNull,
    searchTree,
} from "helpers";
import permissions, { checkPermissions } from "config/permissions";
import { dynamicParamsFilter } from "./helpers";
import { isEmpty, get, isObjectLike } from "lodash";

const SUBMIT_LOCK_SOURCE_NOTIFICATION_ERRORS = ["email", "comment", "customer"];

const LOCK_SOURCE_FORM = "form";

const LOCK_SOURCE_DESTINATIONS = "destinations";

const COLLAPSE_TAB_TYPE = 'appeal';

function mapStateToProps (state, props) {
	const [appeal, id] = extractAppealFromState(state, props);
	const customer = extractCustomerFromState(state, _.get(appeal, 'currentAppeal.customerId'));
	const contactPerson = get(customer, 'currentContactPerson');

	return {
		appeal: appeal.currentAppeal,
		checkReqDynParams: appeal.checkReqDynParams,
		saveAndCreateNew: appeal.saveAndCreateNew,
		appealFeedback: appeal.appealFeedback,
		refreshAppealModal: appeal.refreshAppealModal,
		selectedAppealAction: appeal.selectedAppealAction,
		priorityList: state.appeal.priorityList,
		// destinations: appeal.destinations || [],
		destinations: appeal.destinations, // if destinations are not yet fetched - they are null, once it is an array (even empty) => they are fetched and initialised
		appealDestinationId: get(appeal, 'currentAppeal.destinationId'),
		appealDestinationName:get(appeal, 'currentAppeal.destinationName'),
		loadingDestinations: appeal.loadingDestinations,
		
		formParams: appeal.formParams,
		formHeaderValues: getFormValues(`appeal-form-header-${id}`)(state),
		formHeaderErrors: getFormSyncErrors(`appeal-form-header-${id}`)(state),
		formValues: getFormValues(`appeal-form-${id}`)(state),
		formErrors: getFormSyncErrors(`appeal-form-${id}`)(state),
		modalStatusList: appeal.modalStatusList,
		appealTypes: state.appeal.appealTypes,
		unlockAppeal: appeal.unlockAppeal,
		unlockedAppeal: appeal.unlockedAppeal,
        appealLockSourceList: appeal.lockSourceList,
		closeAppealFlag: appeal.closeAppealFlag,
		
		customerId: _.get(customer, 'currentCustomer.id'),
		customer: customer.currentCustomer,
		contactPerson,
		customerType: get(customer, 'currentCustomer.party.partyType'),
		
		operations: state.user.operations,
		// generateFile: !checkPermissions(permissions.FileOperations.generate_file),
		canGenerateFile: checkPermissions(permissions.FileOperations.generate_file),
		canAddExecutors: checkPermissions(permissions.AppealOperations.action_createAppealDuplet),
		canCreateAppeal: checkPermissions(permissions.AppealOperations.action_createAppeal),
		contentLoading: state.content.contentLoading,
		
		incomePhoneNumber: state.call.incomePhoneNumber,
		
		isValid: isValid(`appeal-form-${id}`)(state),
		showAppealLinkModal: state.ui.showAppealLinkModal,
		showObjectsLinkModal: state.ui.showObjectsLinkModal,
		linkedObjects: state.appeal.linkedObjects,

		currentTab: state.tabs.current,
		appealStatusList: appeal.statusList,
		isSaveAndCreateNew: appeal.isSaveAndCreateNew,

		tabsCollapseState: get(state, `layoutCollapse.${COLLAPSE_TAB_TYPE}.collapseState`)
	};
}

const mapDispatchToProps = {
	// unlockAppealForm,
	saveAppeal,
	getAppealVersion,
	removeRefreshAppealModal,
	setStatusModalVisibility,
	showValidationNotification,
	lockAppealForm,
	createNewAppeal,
	setSaveAndCreateNew,
	// updateCurrentTabUrl,
	setRequiredCustomer,
	setAppealIsSaveAndCreateNew,
	// submitForm: (id) => submit(`appeal-form-${id}`),
	showNotification,
	// touch,
	submit,
	saveFeedback,
	unlockAppealAndClearSourceWithoutForm,
	toggleTabsTripleCollapseState: () => toggleTabsTripleCollapseState(COLLAPSE_TAB_TYPE),
};

@withTranslation()
@withRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class AppealMainContent extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			save: false,
			createNew: false,
			saveAndClose: localStorage.getItem('saveAndClose') === 'true',
			shouldntUnlock: false,
			callQuality: false,
			shouldScrollToError: false,
		};
		this.toggleCheckbox = this.toggleCheckbox.bind(this);
		this.submit = this.submit.bind(this);
		this.refresh = this.refresh.bind(this);
		this.closeRefreshModal = this.closeRefreshModal.bind(this);
	}
	

	setShouldScrollToError = (value) => this.setState({ shouldScrollToError: value });
	
	toggleCheckbox () {
		const saveAndClose = !(localStorage.getItem('saveAndClose') === 'true');
		this.setState({ saveAndClose });
		localStorage.setItem('saveAndClose', saveAndClose.toString());
	};
	
	
	onFormChange = (changedValues, dispatch, props, previousValues) => {
		if (this.state.createNew || this.state.save) {
			this.setState({ createNew: false, save: false });
		}
		changeFormListener(changedValues, dispatch, props, previousValues);
	};
	

	checkRestrictions = (field) => {
		const { restriction } = this.props.appeal;
		return (restriction && restriction[field] && restriction[field] === 1);
	};
	
	shouldRenderField = (field) => {
		const fieldRestriction = get(this.props.appeal, `restriction[${field}]`, 0);
		return fieldRestriction !== 2 && fieldRestriction !== 0;
	};
	
	
	renderOperator = (operator) => {
		const shouldRender = operator.code === 'edit' && !operator.owner;
		if (!shouldRender) {
			return null;
		}
		
		const text = `${operator.codeName} ${operator.name}`;
		
		return (
			<span title={text} className={`${operator.code}Code`}>
                {text}
            </span>
		);
	};
	
	async submit (e, createNew) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		await this.props.setSaveAndCreateNew(this.props.appeal.id, createNew);
		this.submitForm(this.props.appeal.id);
	}

	submitForm = id => {
        const {
			t,
            appeal,
            formValues,
            formHeaderValues,
            formErrors: formMainErrors,
			formHeaderErrors,
            showValidationNotification,
            setRequiredCustomer,
            setStatusModalVisibility,
            customer,
            contactPerson,
            destinations,
            callPhoneNumber,
            modalStatusList,
            saveAppeal,
            postSave,
            saveAndCreateNew,
            removeAppealLockSource,
			unlockAppealAndClearSourceWithoutForm,
			formParams,
			linkedObjects
        } = this.props;
		const formErrors = { ...formMainErrors, ...formHeaderErrors };
		const renderedFormParams = formParams && formParams.blocks.filter(block => dynamicParamsFilter(block, this.shouldRenderField));
        
		if (!isEmpty(formErrors)) {
            this.props.submit(`appeal-form-${id}`);
			this.setShouldScrollToError(true);

            const keysTitles =
				renderedFormParams &&
				renderedFormParams
                    .flatMap(block => block.widgets)
                    .reduce(
                        (acc, curr) => ({
                            ...acc,
                            [curr.key]: curr.title,
                        }),
                        {}
                    );
			// make clear error message in format {widget title}: {formError}
            let parsedErrorMessage = [];
			Object.keys(formErrors).forEach(key => {
				const title = keysTitles[key] || t(`appeal.${key}`); // try to get title from dyn params title, or from dictionary for static fields
				let error = formErrors[key];
				// map object / array error keys
				if (typeof error === 'object') {
					if (Array.isArray(error)) {
						error = error.join(', ');
					} else {
						error = Object.values(error).map(value => value).join(", ");
					}
				}
				parsedErrorMessage.push(`${title} (${error})`);
			});
            showValidationNotification(parsedErrorMessage.join(", "));
        } else {
            const { resolveDate, priority } = formHeaderValues;
            const {
                subject,
                description,
                type,
                objectId,
                destinationFeedback,
                destination,
                solution,
				resolution,
				status,
				timer,
				nextState,
				statusComment,
                ...restValues
            } = formValues;

			const dynamicKeys = renderedFormParams && renderedFormParams.flatMap(block => block.widgets).map(widget => widget.key);
            
			// new logic
			const dynamicFields = {};
			dynamicKeys.forEach(key => {
				const dynValue = restValues[key];
                if (Array.isArray(dynValue)) {
                    if (dynValue.length) {
                        dynamicFields[key] = dynValue.map(value => {
                            return value && value.id ? value.id.toString() : getValueOrNull(value);
                        });
                    } else {
                        dynamicFields[key] = [null];
                    }
                } else if (isObjectLike(dynValue) && !moment.isMoment(dynValue)) {
                    dynamicFields[key] = [getValueOrNull(dynValue.key)];
                } else {
                    dynamicFields[key] = [getValueOrNull(dynValue)];
                }
            });

			const keysToDelete = Object.keys(dynamicFields).filter(key => key.includes("cached_file_values") || key.includes("cached_ajax_options"));
			keysToDelete.forEach(key => {
				delete dynamicFields[key];
			})

			// old logic right after const dynamicKeys = renderedFormParams && renderedFormParams... line
			// const dynamicValues = {};
			// // map values which are actually exist in current form params
			// dynamicKeys && dynamicKeys.forEach(key => {
			// 	if (key in rest) {
			// 		dynamicValues[key] = rest[key];
			// 	}
			// });

			
			
            // const dynamicFields = JSON.parse(JSON.stringify(dynamicValues));

			// // remove cached_file_values added to handle files from knowledgebase template fill
			// const keysToDelete = Object.keys(dynamicFields).filter(key => key.includes("cached_file_values") || key.includes("cached_ajax_options"));
			// keysToDelete.forEach(key => {
			// 	delete dynamicFields[key];
			// })
			
            // // Object.keys(dynamicFields).forEach(key => {
			// dynamicKeys.forEach(key => {
            //     if (Array.isArray(dynamicFields[key])) {
            //         if (dynamicFields[key].length) {
            //             dynamicFields[key] = dynamicFields[key].map(value => {
            //                 return value && value.id ? value.id.toString() : getValueOrNull(value);
            //             });
            //         } else {
            //             dynamicFields[key] = [null];
            //         }
            //     } else if (isObjectLike(dynamicFields[key]) && !moment.isMoment(dynamicFields[key])) {
            //         dynamicFields[key] = [getValueOrNull(dynamicFields[key].key)];
            //     } else {
            //         dynamicFields[key] = [getValueOrNull(dynamicFields[key])];
            //     }
			// 	// else if (dynamicFields[key] && moment(dynamicFields[key], "YYYY-MM-DDThh:mm:ssZ", true).isValid()) {
            //     //     dynamicFields[key] = ["" + moment(dynamicFields[key]).unix() * 1000];
            //     // } 
			// 	// else {
            //     //     dynamicFields[key] = [getValueOrNull(dynamicFields[key])];
            //     // }
            // });
            const filteredDestination = destination.filter(value => value);
            const appealRoutes = [];
            filteredDestination.forEach(i => {
                searchTree(destinations, "result", item => {
                    if (parseInt(item.object.id) === parseInt(i)) {
                        appealRoutes.push(item.object.route);
                    }
                });
            });

            const saveAppealData = {
                appealId: id,
                destination,
                dynamicFields,
                subject,
                description: getValueOrNull(description),
                type: String(get(type, "id")),
                // resolveDate: Number(moment(resolveDate).format("x")),
                resolveDate,
                // priority: priority.value,
				priority,
                solution: getValueOrNull(solution),
                interactionId: appeal.interactionId,
                objectTypeName: null,
                objectType: "appeal",
				objectTypeId: appeal.interactionId,
                objectId: null,
                // status: props.firstLevelAppealAction
                //     ? props.firstLevelAppealAction.toStateName
                //     : get(status, "code"),
				status: get(status, "code"),
                resolution: get(resolution, "id", null),
                customerId: null,
                contactPersonId: null,
                route: appealRoutes,
            };

            if (timer && nextState) {
                saveAppealData.timer = timer;
                saveAppealData.nextState = nextState;
            }

            if (statusComment) {
                saveAppealData.statusComment = statusComment;
            }

            if (customer) {
                const contactsType = [];
                const contactsValue = [];

                saveAppealData.customerId = customer.id;

                if (
                    contactPerson &&
                    (isOrganization(customer.party.partyType) ||
                        isServiceobjectType(customer.party.partyType) ||
                        isIndividual(customer.party.partyType))
                ) {
                    saveAppealData.contactPersonId = contactPerson.id;
                }

                if (destinationFeedback && destinationFeedback.length) {
                    destinationFeedback.forEach((field, key) => {
                        if (field === 0 && callPhoneNumber) {
                            contactsType.push("homePhone");
                            contactsValue.push(callPhoneNumber);
                            destinationFeedback[key] = null;
                        } else {
                            contactsType.push(null);
                            contactsValue.push(null);
                        }
                    });
                    const saveFeedbackData = {
                        data: {
                            appealId: id,
                            customerId: customer.id,
                            contacts: destinationFeedback,
                            contactsType: contactsType,
                            contactsValue: contactsValue,
                            personId:
                                contactPerson &&
                                (isOrganization(customer.party.partyType) ||
                                    isServiceobjectType(customer.party.partyType))
                                    ? contactPerson.id
                                    : null,
                        },
                        jsonType: true,
                    };

                    saveFeedback(saveFeedbackData);
                }
            }

            _.forEach(saveAppealData, (value, key) => {
                if (value && moment(value, "YYYY-MM-DDThh:mm:ssZ", true).isValid()) {
                    saveAppealData[key] = "" + moment(value).unix() * 1000;
                }
            });

            const isRequiredCustomerByObjects =
                get(formValues, "type.requiredObjects") && get(formValues, "type.requiredObjects").includes("CUSTOMER");
            const isCustReq = get(formValues, "type.isCustReq");
            const isRequiredCustomer = isRequiredCustomerByObjects || isCustReq;
            if (isRequiredCustomer && !customer) {
                showValidationNotification("validation.selectCustomer");
                setRequiredCustomer(id, true);
                return;
            }

            if (get(formValues, "type.requiredObjects") && get(formValues, "type.requiredObjects").includes("SERVICE")) {
                const isLinkedObjects = linkedObjects && linkedObjects.length > 0;
                if (!isLinkedObjects) {
                    showValidationNotification("validation.selectServices");
                    return;
                }
            }

            if (modalStatusList.length > 0) {
                setStatusModalVisibility(true, id);
                return;
            }
            // unlock appeal after save (clearup lockList)
            const appealNotificationId = appeal ? appeal.regnum : id;
            saveAppeal(saveAppealData, appealNotificationId).then(success => {
                if (success) {
                    postSave({ saveAndCreateNew: saveAndCreateNew, appealId: id });
					// this.props.setNeedReinitialize(appeal.id, true);
                    if (removeAppealLockSource && typeof removeAppealLockSource === "function") {
                        // On saveAppeal remove both "form" and "destinations" locks on appeal
                        // destinations could still exist which caused not unlocking the appeal and triggering a prompt modal)
                        removeAppealLockSource(LOCK_SOURCE_FORM);
                        removeAppealLockSource(LOCK_SOURCE_DESTINATIONS);
						unlockAppealAndClearSourceWithoutForm(appeal.id);
                    }
                }
            });
        }
    };
	
	refresh () {
		this.props.unlockAppealAndClearSource(this.props.appeal.id);
		this.props.requestInitialData(true);
	}
	
	closeRefreshModal () {
		this.props.removeRefreshAppealModal(this.props.appeal.id);
	}
	
	render () {
		const {
			appeal, unlockedAppeal, t, contentLoading, customer, change,
			customerType, contactPerson, appealTypes, formParams,
			appealFeedback, customerId, canCreateAppeal, formValues, formErrors, formHeaderValues, showAppealLinkModal,
			showObjectsLinkModal, linkedObjects,
			isSaveAndCreateNew, setAppealIsSaveAndCreateNew, appealLockSourceList,
			operators,
			isLockedByOther,
			lockSourceList,
			canGenerateFile,
			callQuality,
			toggleCodeQuality,
		} = this.props;
		
		// const { printPopupIsOpen, callQuality, saveAndClose } = this.state;
		const { printPopupIsOpen, saveAndClose } = this.state;

		
		if (!appeal) return null;
		
		const popupConfig = [
			{
				label: t('appeal.save'),
				clickHandler: (e) => {
					// is used in for proper submit via StatusSelect (to keep track of value regarding createNew appeal or not)
					// setAppealIsSaveAndCreateNew(false, appeal.id);
					// this.submit(e);
					btnSubmitClickHandler(e, false);
				}
			},
			{
				label: t('appeal.saveAndCreateNew'),
				clickHandler: (e) => {
					// is used in for proper submit via StatusSelect (to keep track of value regarding createNew appeal or not)
					// setAppealIsSaveAndCreateNew(true, appeal.id);
					// this.submit(e, true);
					btnSubmitClickHandler(e, true);
				},
				disabled: !canCreateAppeal
			}
		];

		// show corresponding notifications during saving if either comment / mail / customer lockSource are present
		const btnSubmitClickHandler = (e, isCreateNew) => {
			let isPreventSubmit = false;
			if (appealLockSourceList && appealLockSourceList.length > 0) {
				appealLockSourceList.forEach(source => {
					if (SUBMIT_LOCK_SOURCE_NOTIFICATION_ERRORS.includes(source)) {
						isPreventSubmit = true;
						this.props.showNotification({
							type: NotificationTypes.APPEAL_CHANGE_FAILURE,
							options: { field: t(`appealFinishBeforeSave.${source}`), },
							id: `${source}_${new Date().getTime()}`,
						});
					}
				});
			}
			if (!isPreventSubmit) {
				// setAppealIsSaveAndCreateNew(false, appeal.id);
				setAppealIsSaveAndCreateNew(isCreateNew, appeal.id);
				this.submit(e, isCreateNew);
			}
		}
		
		const customerName = (isOrganization(customerType) || isServiceobjectType(customerType)) ?
			get(customer, 'party.officialName') : get(customer, 'party.fullName');
		
		const personName = get(contactPerson, 'party.fullName', '');

		const shouldRenderOperator = operators.find(operator => operator.code === 'edit' && !operator.owner);


		const shouldRenderActionSelect = this.props.appeal.restriction.nextAction !== 0;
	
		
		return (
			<main className='main-appeal'>
				{/* {!this.props.savingAppeal && <Loader />} */}
				<Switch>
					<Route path='/appeals/:appealId/person/:id/:subTab?' render={(props) => {
						if (!contactPerson) return null;
						return (
							<PersonPageContent
								{...props}
								contactPerson={contactPerson}
								personName={personName}
								customerId={customerId}
							/>
						);
					}} />
					<Route path='/appeals/:appealId/customer/:id/:subTab?' render={(props) => {
						if (!customer) return null;
						return (
							<CustomerTabContent
								{...props}
								customer={customer}
								tabsNames={getCustomerTabNames(customerType)}
								customerName={customerName}
								customerLastName={customer.party.lastName}
								customerFirstName={customer.party.firstName}
								customerPatronymic={customer.party.patronymic}
								customerId={customer.id}
								customerType={customerType}
							/>
						);
					}
					} />
					<Route path='/appeals/:appealId/:tab?' render={(props) => (
						<Fragment>
							<div className='appeal-content-wrapper'>
								<NewAppealForm
									t={t}
									formParams={formParams}
									checkRestrictions={this.checkRestrictions}
									shouldRenderField={this.shouldRenderField}
									appeal={appeal}
									unlockAppealForm={this.props.unlockAppealForm}
									destinations={this.props.destinations}
									appealDestinationId={this.props.appealDestinationId}
									appealDestinationName={this.props.appealDestinationName}
									customer={customer}
									selectedAppealAction={this.props.selectedAppealAction}
									formValues={formValues}
									formErrors={formErrors}
									formHeaderValues={formHeaderValues}
									linkedObjects={linkedObjects}
									loadingDestinations={this.props.loadingDestinations}
									onDestinationOpen={this.props.onDestinationOpen}
									canAddExecutors={this.props.canAddExecutors}
									resetActions={this.props.resetActions}
									resetAppealType={this.props.resetAppealType}
									isLoading={this.props.isCentralPartLoading || this.props.loadingParams}
									priorityList={this.props.priorityList}
									needReinitialize={this.props.needReinitialize}
									setNeedReinitialize={this.props.setNeedReinitialize}
									shouldScrollToError={this.state.shouldScrollToError}
									setShouldScrollToError={this.setShouldScrollToError}
									key={appeal.id}
								/>
								
								{
									this.props.refreshAppealModal && (
										<NotificationPortal>
											<div className={notificationStyle.notification}>
												<i className='icon-close' onClick={this.closeRefreshModal} />
												<div className={notificationStyle.appealChangesFailureNote}>
													<i className='icon-error' />
													<span>{t('appeal.reloadAppeal', { num: appeal.num })}</span>
													<button
														onClick={this.refresh}
														className='btn btn-primary m-t-5'
													>
														{t('refresh')}
													</button>
												</div>
											</div>
										</NotificationPortal>
									)
								}
								
								<TabContent
									contentLoading={contentLoading}
									unlockAppealForm={this.props.unlockAppealForm}
									removeAppealLockSource={this.props.removeAppealLockSource}
									resetAppealType={this.props.resetAppealType}
									isLockedByOther={isLockedByOther || this.props.refreshAppealModal || this.props.lockError}
									shouldRenderField={this.shouldRenderField}
									// setTabsOpened={this.props.setTabsOpened}
									// setTabsWidth={this.props.setTabsWidth}
									tabsCollapseState={this.props.tabsCollapseState}
									toggleTabsTripleCollapseState={this.props.toggleTabsTripleCollapseState}
									{...props}
									key={`${appeal && appeal.id}_TabContent`}
								/>
							</div>
							
							<footer className='footer'>
								<div className='toggleWrapper'>
									<CheckBoxToggle
										id='out'
										label={t('appeal.footerCheckBoxLabel')}
										checked={saveAndClose}
										onChange={this.toggleCheckbox}
									/>
								</div>
								<div className={cx('operatorsBlock', {withActions: shouldRenderActionSelect})}>
									{shouldRenderOperator && operators.map(this.renderOperator)}
									{!shouldRenderOperator && this.props.lockError && (
										<span title={this.props.lockError} className={`editCode`}>
											{this.props.lockError}
										</span>
									)}
								</div>
								<div className='footer-control-buttons'>
									{shouldRenderActionSelect && (
										<ActionSelect
											change={change}
											disabled={this.checkRestrictions("statusId")}
											unlockAppealForm={this.props.unlockAppealForm}
											permission={this.props.appeal.restriction.nextAction}
										/>
									)}
									<div className="divider" />
									<StatusSelect
										change={change}
										disabled={this.checkRestrictions('statusId')}
										unlockAppealForm={this.props.unlockAppealForm}
										formValues={formValues}
										permission={this.props.appeal.restriction.statusId}
										onSubmitButtonClick={() => this.setState({ save: false })}
										onStatusModalConfirm={() => this.submit(null, isSaveAndCreateNew)}
										// key={appeal.id}
									/>
									<ButtonSelectPopup
										text={t('appeal.save')}
										popupConfig={popupConfig}
										onClickBtn={(e) => btnSubmitClickHandler(e, false)}
										disabled={
											this.props.refreshAppealModal ||
											!(appealLockSourceList && appealLockSourceList.includes("form")) ||
											isLockedByOther ||
											this.props.savingAppeal ||
											this.props.isCentralPartLoading ||
											this.props.loadingParams
										}
										up
									/>
								</div>
							</footer>
						
						</Fragment>
					)} />
				</Switch>
				{
					callQuality && <ViewListQuality onClose={toggleCodeQuality} appeal={appeal} />
				}
				{
					showAppealLinkModal && <LinkAppeal appeal={appeal} />
				}
				{
					showObjectsLinkModal && <LinkObjects id={appeal.id} customerId={appeal.customerId} />
				}
			</main>
		);
	}
}

AppealMainContent.propTypes = {
	appeal: PropTypes.object,
	customer: PropTypes.object,
};
